import { useState, useEffect } from 'react';

const HomePage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const products = [
    {
      id: 1,
      name: 'Garnet Box',
      price: '$32',
      image: 'https://public.readdy.ai/ai/img_res/23e3080d89dddba12d9a14ed8f0f8b34.jpg',
      description: 'Deep crimson beauty in crystal form'
    },
    {
      id: 2,
      name: 'Ruby Box',
      price: '$35',
      image: 'https://readdy.ai/api/search-image?query=Exquisite%20Japanese%20ruby-colored%20kohakutou%20crystal%20candies%20in%20luxury%20gift%20packaging%2C%20jewel-like%20translucent%20sweets%20with%20warm%20lighting%2C%20minimalist%20aesthetic%2C%20clean%20white%20background%2C%20premium%20confectionery%20presentation&width=400&height=400&seq=ruby1&orientation=squarish',
      description: 'Ruby-like brilliance in every bite'
    },
    {
      id: 3,
      name: 'Emerald Box',
      price: '$38',
      image: 'https://readdy.ai/api/search-image?query=Stunning%20emerald%20green%20Japanese%20kohakutou%20crystal%20candies%20in%20sophisticated%20gift%20box%2C%20translucent%20gem-like%20sweets%20with%20natural%20lighting%2C%20elegant%20minimalist%20design%2C%20clean%20white%20background%2C%20artisan%20quality%20presentation&width=400&height=400&seq=emerald1&orientation=squarish',
      description: 'Emerald green translucent elegance'
    },
    {
      id: 4,
      name: 'Sapphire Box',
      price: '$42',
      image: 'https://readdy.ai/api/search-image?query=Premium%20sapphire%20blue%20Japanese%20kohakutou%20crystal%20candies%20in%20luxury%20packaging%2C%20jewel-like%20translucent%20confectionery%20with%20soft%20studio%20lighting%2C%20minimalist%20aesthetic%20design%2C%20clean%20white%20background%2C%20high-end%20gift%20presentation&width=400&height=400&seq=sapphire1&orientation=squarish',
      description: 'Mystical sapphire blue beauty'
    }
  ];

  // Mobile carousel products
  const mobileCarouselProducts = [
    {
      id: 1,
      name: 'Garnet Box',
      price: '$32',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20handcrafted%20Japanese%20kohakutou%20crystal%20candies%20in%20deep%20red%20garnet%20colors%2C%20arranged%20in%20an%20elegant%20minimalist%20gift%20box%20with%20soft%20lighting%2C%20premium%20packaging%20design%2C%20clean%20white%20background%20with%20subtle%20shadows%2C%20artisan%20confectionery%20photography&width=300&height=300&seq=garnet2&orientation=squarish',
    },
    {
      id: 2,
      name: 'Ruby Box',
      price: '$35',
      image: 'https://readdy.ai/api/search-image?query=Exquisite%20Japanese%20ruby-colored%20kohakutou%20crystal%20candies%20in%20luxury%20gift%20packaging%2C%20jewel-like%20translucent%20sweets%20with%20warm%20lighting%2C%20minimalist%20aesthetic%2C%20clean%20white%20background%2C%20premium%20confectionery%20presentation&width=300&height=300&seq=ruby2&orientation=squarish',
    },
    {
      id: 3,
      name: 'Custom Gem Box',
      price: 'From $45',
      image: 'https://readdy.ai/api/search-image?query=Luxurious%20custom%20Japanese%20kohakutou%20crystal%20candies%20in%20various%20gemstone%20colors%2C%20personalized%20gift%20box%20with%20elegant%20presentation%2C%20translucent%20jewel-like%20sweets%2C%20minimalist%20aesthetic%2C%20clean%20white%20background%2C%20premium%20artisan%20confectionery&width=300&height=300&seq=custom1&orientation=squarish',
    },
    {
      id: 4,
      name: 'Emerald Box',
      price: '$38',
      image: 'https://readdy.ai/api/search-image?query=Stunning%20emerald%20green%20Japanese%20kohakutou%20crystal%20candies%20in%20sophisticated%20gift%20box%2C%20translucent%20gem-like%20sweets%20with%20natural%20lighting%2C%20elegant%20minimalist%20design%2C%20clean%20white%20background%2C%20artisan%20quality%20presentation&width=300&height=300&seq=emerald2&orientation=squarish',
    }
  ];

  const testimonials = [
    {
      name: 'Sarah M.',
      text: 'These are absolutely stunning! Perfect for my book club gathering. Everyone was amazed by how beautiful they looked.',
      rating: 5
    },
    {
      name: 'Jessica L.',
      text: 'Brought these to a colleague\'s farewell party. They were the talk of the event! So unique and Instagram-worthy.',
      rating: 5
    },
    {
      name: 'Emily R.',
      text: 'As someone who\'s been to Japan, these taste authentic and the presentation is flawless. Perfect guilt-free treat!',
      rating: 5
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-[#ADB3CA]/20">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
          <div className="flex justify-between items-center h-14 sm:h-16">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/0ac043fc87c29cdda4ac90f2674639bd/54f2a6276ea9690ef72017d136647d70.png"
                alt="SweetGem"
                className="h-5 sm:h-8 w-auto max-w-[100px] sm:max-w-none object-contain"
              />
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="#about" className="text-[#968980] hover:text-[#687764] transition-colors cursor-pointer">About Us</a>
              <a href="#products" className="text-[#968980] hover:text-[#687764] transition-colors cursor-pointer">Products</a>
              <a href="#contact" className="text-[#968980] hover:text-[#687764] transition-colors cursor-pointer">Contact</a>
            </nav>
            <div className="flex space-x-2 sm:space-x-4">
              <button className="bg-[#EEB1A6] text-white px-2 sm:px-6 py-1.5 sm:py-2 rounded-full hover:bg-[#e8a094] transition-colors whitespace-nowrap cursor-pointer text-xs sm:text-base">
                Shop Gems
              </button>
              <button className="border border-[#687764] text-[#687764] px-2 sm:px-6 py-1.5 sm:py-2 rounded-full hover:bg-[#687764] hover:text-white transition-colors whitespace-nowrap cursor-pointer text-xs sm:text-base">
                Custom Gifts
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative min-h-screen sm:h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/0ac043fc87c29cdda4ac90f2674639bd/ca7e9069d7838105be09424f12664c58.jpeg"
            alt="Handcrafted Japanese Crystal Candies"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-white/85 via-[#ADB3CA]/15 to-transparent"></div>
        </div>
        <div className={`relative z-10 w-full px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="max-w-2xl text-center sm:text-left pt-8 sm:pt-0">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-[#2D3748] mb-4 sm:mb-6 leading-tight px-2 sm:px-0" style={{ fontFamily: '"Playfair Display", serif' }}>
              Beauty You Can Taste.
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-[#4A5568] mb-8 sm:mb-8 leading-relaxed px-2 sm:px-0">
              Handcrafted kohakutou made with traditional Japanese kanten.
              <span className="block mt-2"> Beautiful, plant-based treats that express gratitude and connection through mindful gifting.</span>
            </p>
            <div className="flex flex-col space-y-3 px-4 sm:px-0 sm:flex-row sm:space-y-0 sm:space-x-4">
              <button className="bg-[#687764] text-white px-8 py-4 rounded-full text-base sm:text-lg hover:bg-[#5a6b57] transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto">
                Shop Now
              </button>
              <button className="bg-[#ADB3CA] text-white px-8 py-4 rounded-full text-base sm:text-lg hover:bg-[#9ca3af] transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto">
                Create Your Gift
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile-Only Product Carousel */}
      <section className="block md:hidden py-8 bg-gradient-to-br from-white to-[#EEE0CE]/30">
        <div className="w-full px-4">
          <div className="text-center mb-6">
            <h3 className="text-2xl font-serif text-[#968980] mb-2" style={{ fontFamily: '"Playfair Display", serif' }}>
              Our Signature Sweets
            </h3>
            <p className="text-sm text-[#687764]">
              Swipe to explore our edible jewels.
            </p>
          </div>
          
          <div className="relative">
            <div className="flex overflow-x-auto scrollbar-hide space-x-4 pb-4" style={{ scrollSnapType: 'x mandatory', scrollBehavior: 'smooth' }}>
              {mobileCarouselProducts.map((product) => (
                <div 
                  key={product.id} 
                  className="flex-shrink-0 w-48 bg-white rounded-[20px] shadow-lg hover:shadow-xl transition-all duration-300 p-4"
                  style={{ scrollSnapAlign: 'start' }}
                  data-product-shop
                >
                  <div className="relative overflow-hidden rounded-2xl bg-gray-50 mb-3">
                    <img 
                      src={product.image}
                      alt={product.name}
                      className="w-full h-36 object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
                  </div>
                  <h4 className="text-base font-semibold text-[#968980] mb-1 text-center">{product.name}</h4>
                  <p className="text-lg font-bold text-[#687764] mb-3 text-center">{product.price}</p>
                  <button className="w-full bg-[#EEB1A6] text-white py-2 px-4 rounded-full text-sm hover:bg-[#e8a094] transition-colors whitespace-nowrap cursor-pointer">
                    View Details
                  </button>
                </div>
              ))}
            </div>
            
            {/* Optional scroll indicators */}
            <div className="flex justify-center mt-4 space-x-2">
              {mobileCarouselProducts.map((_, index) => (
                <div 
                  key={index}
                  className="w-2 h-2 rounded-full bg-[#ADB3CA]/30"
                ></div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Brand Story */}
      <section className="py-12 sm:py-20 bg-gradient-to-br from-[#EEE0CE] to-[#ADB3CA]/20">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <h3 className="text-2xl sm:text-4xl font-serif text-[#968980] mb-4 sm:mb-6 text-center lg:text-left" style={{ fontFamily: '"Playfair Display", serif' }}>
                What is SweetGem?
              </h3>
              <p className="text-base sm:text-lg text-[#687764] mb-4 sm:mb-6 leading-relaxed text-center lg:text-left">
                SweetGem is a premium Japanese confectionery brand offering jewel-like kohakutou made from traditional kanten (agar). Each piece embodies four core values: Beauty, Bespoke craftsmanship, Wellness, and Gratitude & Connection.
              </p>
              <p className="text-base sm:text-lg text-[#687764] mb-6 sm:mb-8 leading-relaxed text-center lg:text-left">
                Every crystal candy is handcrafted with care, creating plant-based, Instagram-worthy treats perfect for expressing appreciation to colleagues, friends, and loved ones.
              </p>
              <div className="grid grid-cols-2 gap-6 sm:gap-8 max-w-lg mx-auto lg:max-w-none lg:mx-0">
                <div className="text-center group">
                  <div className="w-16 sm:w-20 h-16 sm:h-20 bg-gradient-to-br from-[#EEB1A6] to-[#e8a094] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 shadow-lg group-hover:shadow-xl transition-all duration-300 border-2 border-white/20">
                    <i className="ri-heart-line text-2xl sm:text-3xl text-white"></i>
                  </div>
                  <h4 className="font-bold text-[#968980] mb-2 sm:mb-3 text-base sm:text-lg tracking-wide">Beauty</h4>
                  <p className="text-sm sm:text-base text-[#687764] leading-relaxed font-medium">Inspired by Japanese<br />minimalist aesthetics</p>
                </div>
                <div className="text-center group">
                  <div className="w-16 sm:w-20 h-16 sm:h-20 bg-gradient-to-br from-[#ADB3CA] to-[#9ca3af] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 shadow-lg group-hover:shadow-xl transition-all duration-300 border-2 border-white/20">
                    <i className="ri-tools-line text-2xl sm:text-3xl text-white"></i>
                  </div>
                  <h4 className="font-bold text-[#968980] mb-2 sm:mb-3 text-base sm:text-lg tracking-wide">Craftsmanship</h4>
                  <p className="text-sm sm:text-base text-[#687764] leading-relaxed font-medium">Artisan expertise<br />&amp; attention to detail</p>
                </div>
                <div className="text-center group">
                  <div className="w-16 sm:w-20 h-16 sm:h-20 bg-gradient-to-br from-[#687764] to-[#5a6b57] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 shadow-lg group-hover:shadow-xl transition-all duration-300 border-2 border-white/20">
                    <i className="ri-leaf-line text-2xl sm:text-3xl text-white"></i>
                  </div>
                  <h4 className="font-bold text-[#968980] mb-2 sm:mb-3 text-base sm:text-lg tracking-wide">Wellness</h4>
                  <p className="text-sm sm:text-base text-[#687764] leading-relaxed font-medium">Plant-based &amp; healthy<br />mindful indulgence</p>
                </div>
                <div className="text-center group">
                  <div className="w-16 sm:w-20 h-16 sm:h-20 bg-gradient-to-br from-[#968980] to-[#7a7570] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 shadow-lg group-hover:shadow-xl transition-all duration-300 border-2 border-white/20">
                    <i className="ri-gift-line text-2xl sm:text-3xl text-white"></i>
                  </div>
                  <h4 className="font-bold text-[#968980] mb-2 sm:mb-3 text-base sm:text-lg tracking-wide">Gratitude &amp; Connection</h4>
                  <p className="text-sm sm:text-base text-[#687764] leading-relaxed font-medium">Expressing appreciation<br />through thoughtful gifts</p>
                </div>
              </div>
            </div>
            <div className="relative order-1 lg:order-2">
              <img 
                src="https://static.readdy.ai/image/0ac043fc87c29cdda4ac90f2674639bd/4d2a770eddeddec61b22fa453b48664a.png"
                alt="Wellness lifestyle"
                className="w-full h-64 sm:h-auto rounded-lg shadow-lg object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Featured Products */}
      <section id="products" className="py-12 sm:py-20 bg-white">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
          <div className="text-center mb-8 sm:mb-16">
            <h3 className="text-2xl sm:text-4xl font-serif text-[#968980] mb-2 sm:mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
              Signature Collection
            </h3>
            <p className="text-base sm:text-lg text-[#687764] max-w-2xl mx-auto px-4 sm:px-0">
              Our jewel-inspired crystal candy collection. Each box offers unique colors and flavors that sparkle like precious gems.
            </p>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8" data-product-shop>
            {products.map((product) => (
              <div key={product.id} className="group cursor-pointer bg-gradient-to-b from-white to-[#ADB3CA]/5 rounded-lg p-2 sm:p-4 hover:shadow-lg transition-all duration-300">
                <div className="relative overflow-hidden rounded-lg bg-gray-50 mb-2 sm:mb-4">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-40 sm:h-80 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300"></div>
                </div>
                <h4 className="text-sm sm:text-xl font-semibold text-[#968980] mb-1 sm:mb-2">{product.name}</h4>
                <p className="text-xs sm:text-base text-[#687764] mb-2 sm:mb-3 hidden sm:block">{product.description}</p>
                <div className="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                  <span className="text-lg sm:text-2xl font-bold text-[#687764]">{product.price}</span>
                  <button className="bg-[#EEB1A6] text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-full hover:bg-[#e8a094] transition-colors whitespace-nowrap cursor-pointer text-xs sm:text-base w-full sm:w-auto">
                    View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-8 sm:mt-12 px-4 sm:px-0">
            <button className="border-2 border-[#ADB3CA] text-[#ADB3CA] px-6 sm:px-8 py-3 rounded-full text-base sm:text-lg hover:bg-[#ADB3CA] hover:text-white transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto">
              View All Products
            </button>
          </div>
        </div>
      </section>

      {/* Wellness Section */}
      <section className="py-12 sm:py-20 bg-gradient-to-r from-[#968980]/10 to-[#EEE0CE]/50">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            <div className="relative order-2 lg:order-1">
              <img 
                src="https://readdy.ai/api/search-image?query=Close-up%20of%20translucent%20kanten%20agar%20ingredients%20and%20finished%20kohakutou%20crystal%20candies%2C%20natural%20plant-based%20materials%2C%20clean%20minimalist%20composition%20with%20soft%20lighting%2C%20wellness%20and%20health%20concept%2C%20organic%20textures%20in%20neutral%20tones&width=600&height=500&seq=kanten1&orientation=landscape"
                alt="About Kanten"
                className="w-full h-48 sm:h-auto rounded-lg shadow-lg object-cover"
              />
            </div>
            <div className="order-1 lg:order-2">
              <h3 className="text-2xl sm:text-4xl font-serif text-[#968980] mb-4 sm:mb-6 text-center lg:text-left" style={{ fontFamily: '"Playfair Display", serif' }}>
                About Kanten<br />
                <span className="text-[#687764]">Wellness</span>
              </h3>
              <p className="text-base sm:text-lg text-[#687764] mb-4 sm:mb-6 leading-relaxed text-center lg:text-left">
                Kanten is a natural plant-based gelling agent made from seaweed. It's low in calories, rich in fiber, and completely vegan-friendly—a healthy ingredient rooted in Japanese tradition.
              </p>
              <p className="text-base sm:text-lg text-[#687764] mb-6 sm:mb-8 leading-relaxed text-center lg:text-left">
                Our kohakutou uses this traditional kanten to create a mindful sweet experience that combines beauty with wellness, perfect for health-conscious gift-givers.
              </p>
              <div className="space-y-3 sm:space-y-4 max-w-md mx-auto lg:max-w-none lg:mx-0">
                <div className="flex items-center space-x-3 justify-center lg:justify-start">
                  <div className="w-5 sm:w-6 h-5 sm:h-6 bg-[#ADB3CA] rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                  </div>
                  <span className="text-[#687764] text-sm sm:text-base">100% Plant-based &amp; Vegan</span>
                </div>
                <div className="flex items-center space-x-3 justify-center lg:justify-start">
                  <div className="w-5 sm:w-6 h-5 sm:h-6 bg-[#ADB3CA] rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                  </div>
                  <span className="text-[#687764] text-sm sm:text-base">Low calorie, high in fiber</span>
                </div>
                <div className="flex items-center space-x-3 justify-center lg:justify-start">
                  <div className="w-5 sm:w-6 h-5 sm:h-6 bg-[#ADB3CA] rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                  </div>
                  <span className="text-[#687764] text-sm sm:text-base">No artificial additives</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="py-12 sm:py-20 bg-gradient-to-r from-[#EEB1A6]/20 via-[#ADB3CA]/15 to-[#EEE0CE]/40">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <h3 className="text-2xl sm:text-4xl font-serif text-[#968980] mb-2 sm:mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
            Don't Miss Our Special Offers
          </h3>
          <p className="text-base sm:text-lg text-[#687764] mb-6 sm:mb-8 px-2 sm:px-0">
            Subscribe to our newsletter for exclusive access to new products and limited offers.
            <span className="block mt-1 sm:mt-0 sm:inline"> Get <span className="font-semibold text-[#EEB1A6]">10% OFF</span> your first order when you sign up!</span>
          </p>
          <form 
            action="https://readdy.ai/api/form/d3uqajo1gb80hj212c70"
            method="POST"
            data-readdy-form
            className="max-w-md mx-auto px-4 sm:px-0"
          >
            <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4">
              <input 
                type="email"
                name="email"
                placeholder="Enter your email address"
                required
                className="flex-1 px-4 py-3 border border-[#ADB3CA]/30 rounded-full focus:outline-none focus:ring-2 focus:ring-[#ADB3CA] focus:border-transparent text-sm"
              />
              <button 
                type="submit"
                className="bg-[#687764] text-white px-6 sm:px-8 py-3 rounded-full hover:bg-[#5a6b57] transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto"
              >
                Subscribe
              </button>
            </div>
          </form>
        </div>
      </section>

      {/* Customer Reviews */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
          <div className="text-center mb-8 sm:mb-16">
            <h3 className="text-2xl sm:text-4xl font-serif text-[#968980] mb-2 sm:mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
              What Our Customers Say
            </h3>
            <p className="text-base sm:text-lg text-[#687764] px-4 sm:px-0">
              Hear from our delighted customers who chose SweetGem for their special moments.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gradient-to-b from-[#ADB3CA]/5 to-[#EEE0CE]/20 p-4 sm:p-8 rounded-lg border border-[#ADB3CA]/10">
                <div className="flex mb-3 sm:mb-4 justify-center md:justify-start">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#EEB1A6] text-base sm:text-lg"></i>
                  ))}
                </div>
                <p className="text-[#687764] mb-4 sm:mb-6 leading-relaxed text-center md:text-left text-sm sm:text-base">
                  "{testimonial.text}"
                </p>
                <div className="font-semibold text-[#968980] text-center md:text-left text-sm sm:text-base">
                  {testimonial.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-20 bg-gradient-to-r from-[#968980] to-[#687764] text-white">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <h3 className="text-2xl sm:text-4xl font-serif mb-4 sm:mb-6 text-white" style={{ fontFamily: '"Playfair Display", serif' }}>
            Co-create Your Signature Gift
          </h3>
          <p className="text-base sm:text-xl mb-6 sm:mb-8 text-white/90 px-2 sm:px-0">
            Customize colors, flavors, and packaging to create a one-of-a-kind gift box that perfectly expresses your appreciation.
          </p>
          <div className="flex flex-col space-y-4 px-4 sm:px-0 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-6">
            <button className="bg-[#EEB1A6] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg hover:bg-[#e8a094] transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto">
              Create Custom Gift
            </button>
            <button className="border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg hover:bg-white hover:text-[#687764] transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto">
              Corporate Gifting
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-[#1a1a1a] via-[#2d2d2d] to-[#1a1a1a] text-white py-12 sm:py-16">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
            <div className="col-span-1 sm:col-span-2 text-center sm:text-left">
              <img 
                src="https://static.readdy.ai/image/0ac043fc87c29cdda4ac90f2674639bd/54f2a6276ea9690ef72017d136647d70.png"
                alt="SweetGem"
                className="h-5 sm:h-8 w-auto max-w-[120px] sm:max-w-none object-contain mb-3 sm:mb-4 mx-auto sm:mx-0"
              />
              <p className="text-[#d4d4d8] mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
                Handcrafted Japanese crystal candies made with traditional kanten, expressing gratitude through beautiful, mindful gifts.
              </p>
              <div className="flex space-x-4 justify-center sm:justify-start">
                <a href="#" className="w-8 sm:w-10 h-8 sm:h-10 bg-gradient-to-br from-[#3d3d3d] to-[#2a2a2a] rounded-full flex items-center justify-center hover:from-[#EEB1A6] hover:to-[#e8a094] transition-all duration-300 cursor-pointer border border-[#4a4a4a]">
                  <i className="ri-instagram-line text-sm sm:text-lg"></i>
                </a>
                <a href="#" className="w-8 sm:w-10 h-8 sm:h-10 bg-gradient-to-br from-[#3d3d3d] to-[#2a2a2a] rounded-full flex items-center justify-center hover:from-[#EEB1A6] hover:to-[#e8a094] transition-all duration-300 cursor-pointer border border-[#4a4a4a]">
                  <i className="ri-facebook-line text-sm sm:text-lg"></i>
                </a>
                <a href="#" className="w-8 sm:w-10 h-8 sm:h-10 bg-gradient-to-br from-[#3d3d3d] to-[#2a2a2a] rounded-full flex items-center justify-center hover:from-[#EEB1A6] hover:to-[#e8a094] transition-all duration-300 cursor-pointer border border-[#4a4a4a]">
                  <i className="ri-twitter-line text-sm sm:text-lg"></i>
                </a>
              </div>
            </div>
            <div className="text-center sm:text-left">
              <h5 className="font-semibold mb-3 sm:mb-4 text-[#f4f4f5] text-sm sm:text-base">Shop</h5>
              <ul className="space-y-2 text-[#a1a1aa] text-sm sm:text-base">
                <li><a href="#" className="hover:text-[#EEB1A6] transition-colors cursor-pointer">All Products</a></li>
                <li><a href="#" className="hover:text-[#EEB1A6] transition-colors cursor-pointer">Gift Boxes</a></li>
                <li><a href="#" className="hover:text-[#EEB1A6] transition-colors cursor-pointer">Custom Orders</a></li>
                <li><a href="#" className="hover:text-[#EEB1A6] transition-colors cursor-pointer">Corporate Gifts</a></li>
              </ul>
            </div>
            <div className="text-center sm:text-left">
              <h5 className="font-semibold mb-3 sm:mb-4 text-[#f4f4f5] text-sm sm:text-base">Support</h5>
              <ul className="space-y-2 text-[#a1a1aa] text-sm sm:text-base">
                <li><a href="#" className="hover:text-[#EEB1A6] transition-colors cursor-pointer">About Us</a></li>
                <li><a href="#" className="hover:text-[#EEB1A6] transition-colors cursor-pointer">Contact</a></li>
                <li><a href="#" className="hover:text-[#EEB1A6] transition-colors cursor-pointer">FAQ</a></li>
                <li><a href="#" className="hover:text-[#EEB1A6] transition-colors cursor-pointer">Shipping &amp; Returns</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-[#4a4a4a] mt-8 sm:mt-12 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="text-[#a1a1aa] text-xs sm:text-sm text-center sm:text-left">
              © 2024 SweetGem. All rights reserved.
            </p>
            <a href="https://readdy.ai/?origin=logo" className="text-[#a1a1aa] hover:text-[#EEB1A6] text-xs sm:text-sm transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
